import addSpaceToNumber from "./format-number"

const $cylTop = $("[data-profit=cyl-top-green]")
const $cylMid = $("[data-profit=cyl-mid-green]")
const $cylSum = $("[data-profit=cyl-sum-first]")
const $cylMobileTop = $("[data-profit=cyl-mobile-top-green]")
const $cylMobileMid = $("[data-profit=cyl-mobile-mid-green]")

export const cylStateOneGreen = (MIN_VAL) => {
  $cylSum.text(addSpaceToNumber(MIN_VAL))

  $cylTop.css({
    transform: `translateY(-57px)`,
  })

  $cylMid.css({
    transform: `scaleY(40)`,
  })

  $cylMobileTop.css({
    transform: `translateX(83px)`,
  })

  $cylMobileMid.css({
    transform: `scaleX(90)`,
  })
}

export const cylStateTwoGreen = (MAX_VAL) => {
  $cylSum.text(addSpaceToNumber(MAX_VAL))
}

export const cylStateThreeGreen = (inputVal, growStep) => {
  $cylSum.text(addSpaceToNumber(inputVal))

  $cylTop.css({
    transform: `translateY(-${57 + growStep}px)`,
  })

  $cylMid.css({
    transform: `scaleY(${40 + growStep})`,
  })

  $cylMobileTop.css({
    transform: `translateX(${83 + growStep}px)`,
  })

  $cylMobileMid.css({
    transform: `scaleX(${90 + growStep})`,
  })
}



// WEBPACK FOOTER //
// ./src/blocks/barrels/cyl-green.js